import React, { useState, useRef, useEffect } from "react";
import TextInput from "../TextInput";
import SelectInputTrack from "../utilities/SelectInputTrack";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import ProviderCbxFilter from "../utilities/ProviderCbxFilter";
import { successMsg } from "../SuccessHandler";
import dayjs from "dayjs";
import ErrorCodes from "../../constants/ErrorCodes";
import { useInsertFunctions } from "../../functions";

const NewRaceModal = ({
  gameProviders,
  setSelectedProvider,
  selectedProvider,
  userInfo,
  setRefreshInfo,
  refreshInfo,
  setRefreshEntries,
  refreshEntries,
  setSelectOption,
  getActiveTracks,
  setSessionNoLongerExists,
  setOpenNewRaceModal,
  getTracksListCbx,
  tracksListCbx,
}) => {
  const [newRace, setNewRace] = useState({
    LogonSessionID: "",
    ProviderID: 0,
    TotalRaces: 0,
    TotalEntries: 0,
    RaceDate: new Date(),
    TrackID: "",
    LastModificationUser: "",
    TrackCode: "",
  });
  const closeButtonRef = useRef();
  const [isOpen, setIsOpen] = useState(true);
  const [openTracks, setOpenTracks] = useState({
    TrackID: 0,
    RaceID: 0,
    RaceNumber: 0,
    TrackCode: "",
    TrackName: "",
  });
  const [saveRace, setSaveRace] = useState(false);
  const [selectedRaceDate, setSelectedRaceDate] = useState("");
  const { insertDefaultRace } = useInsertFunctions();
  const [errors, setErrors] = useState({
    totalRaces: "",
    totalEntries: "",
  });

  const shortDate = (date) => {
    return (
      date.getFullYear() +
      "-" +
      ("0" + (date.getMonth() + 1)).slice(-2) +
      "-" +
      ("0" + date.getDate()).slice(-2)
    );
  };

  useEffect(() => {
    if (saveRace && shortDate(selectedRaceDate) === shortDate(new Date())) {
      const exists = tracksListCbx.some(
        (track) => track.TrackID === openTracks.TrackID,
      );

      if (exists) {
        showRaceInfo(
          openTracks.TrackID,
          openTracks.RaceID,
          openTracks.RaceNumber,
          openTracks.TrackCode,
          openTracks.TrackName,
        );
      }
    }
  }, [tracksListCbx, saveRace]);

  // This function is called when the user clicks on the off race row.
  const showRaceInfo = (trackID, raceID, raceNum, trackCode, trackName) => {
    setRefreshInfo(!refreshInfo);
    setRefreshEntries(!refreshEntries);
    setSelectOption(
      trackID,
      trackName,
      raceID,
      raceNum,
      trackCode,
      "open",
      "O",
    );

    const exists = tracksListCbx.some((track) => track.TrackID === trackID);
    const timeout = setTimeout(() => {
      if (exists && document.getElementById("idCollapse" + trackID) !== null) {
        document.getElementById("idCollapse" + trackID).classList.add("show");

        // This function is responsible for moving the scroll position to the Track opens when clicking on the off race row.
        const trackElement = document.getElementById("idCollapse" + trackID);
        trackElement.classList.add("show");

        if (trackElement && trackElement.parentNode) {
          const scrollOffset = 50; // Ajusta este valor según tus necesidades
          const trackPosition = trackElement.parentNode.offsetTop;
          const scrollToPosition = trackPosition - scrollOffset;

          trackElement.parentNode.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest",
          });

          trackElement.parentNode.scrollTop -= scrollToPosition;
        }
      }
    }, 2000);
    setSaveRace(false);
    setOpenTracks({
      TrackID: 0,
      RaceID: 0,
      RaceNumber: 0,
      TrackCode: "",
      TrackName: "",
    });

    return () => clearTimeout(timeout);
  };

  const onChangeTrackCode = (trackID, trackCode, providerID) => {
    setNewRace({
      ...newRace,
      TrackID: trackID,
      TrackCode: trackCode,
      ProviderID: providerID,
      errors: {},
    });
    setIsOpen(true);
    setErrors({ ...errors, trackId: "" });
  };

  // This function executes the onChange for changes made to the Race Info fields.
  const onChangeNewRace = (e) => {
    const { name, value } = e.target;
    let newValue = value;

    if (name === "TotalRaces" || name === "TotalEntries") {
      const errorKey = name === "TotalRaces" ? "totalRaces" : "totalEntries";

      if (value === "") {
        setNewRace({ ...newRace, [name]: "" });
        setErrors({ ...errors, [errorKey]: "" });
        return;
      }

      if (!/^\d+$/.test(value)) return;

      const numberValue = parseInt(value, 10);

      if (numberValue > 20) {
        setErrors({
          ...errors,
          [errorKey]: "Max 20",
        });
        return;
      }

      newValue = numberValue;
      setErrors({ ...errors, [errorKey]: "" });
    }

    setNewRace({
      ...newRace,
      [name]: newValue,
    });
  };

  useEffect(() => {
    setSelectedRaceDate(newRace.RaceDate);
  }, [newRace.RaceDate]);

  const insertRace = async () => {
    const _errors = {};

    if (newRace.TrackID === "") _errors.trackId = "Track is required";
    if (!newRace.TotalRaces) _errors.totalRaces = "Total Races is required";
    if (newRace.TotalRaces <= 0) _errors.totalRaces = "Total Races is invalid";
    if (!newRace.TotalEntries)
      _errors.totalEntries = "Total Runners is required";
    if (newRace.TotalEntries <= 0)
      _errors.totalEntries = "Total Runners is invalid";

    setErrors(_errors);
    if (Object.keys(_errors).length === 0) {
      const res = await insertDefaultRace(
        {
          ...newRace,
          RaceDate: dayjs(newRace.RaceDate).format("MM/DD/YYYY"),
          LastModificationUser: userInfo.IdUser,
        },
        userInfo.LogonSessionID,
      );

      if (res?.error) {
        if (
          res.Result === ErrorCodes.InvalidSession ||
          res.Result === ErrorCodes.SessionNoLongerExists
        ) {
          setSessionNoLongerExists(true);
        }
        return;
      } else {
        if (res.Result === 0) {
          if (res.RaceID !== 0) {
            getActiveTracks(
              true,
              true,
              res.RaceID,
              newRace.TrackID,
              "",
              newRace.TrackCode,
              res.RaceNumber,
            );

            setOpenTracks({
              TrackID: newRace.TrackID,
              RaceID: res.RaceID,
              RaceNumber: res.RaceNumber,
              TrackCode: newRace.TrackCode,
              TrackName: newRace.TrackName,
            });

            setSaveRace(true);
          }
          setNewRace({
            LogonSessionID: "",
            ProviderID: 0,
            TotalRaces: 0,
            TotalEntries: 0,
            RaceDate: new Date(),
            TrackID: "",
            LastModificationUser: "",
            TrackCode: "",
          });
          successMsg("Race Saved");
          closeButtonRef.current.click();
          setOpenNewRaceModal(false);
          setIsOpen(false);
        }
      }
    }
  };

  useEffect(() => {
    getTracksListCbx(selectedProvider);
    setNewRace({
      ...newRace,
      TrackID: "",
      TrackCode: "",
    });
  }, [selectedProvider]);

  const closeModalNewRace = () => {
    setNewRace({
      LogonSessionID: "",
      ProviderID: 0,
      TotalRaces: 0,
      TotalEntries: 0,
      RaceDate: new Date(),
      TrackID: "",
      LastModificationUser: "",
      TrackCode: "",
    });
    setIsOpen(false);
    setSelectedProvider(-1);
    setOpenNewRaceModal(false);
  };

  return (
    <>
      <div
        className="modal fade"
        data-keyboard="false"
        data-backdrop="static"
        id="newRaceModal"
        role="dialog"
        aria-labelledby="newRaceModal"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header headerModals">
              <h5 className="modal-title" id="newRaceModal">
                New Race
              </h5>
              <span
                data-dismiss="modal"
                ref={closeButtonRef}
                style={{ cursor: "inherit" }}
              ></span>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => closeModalNewRace()}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="modal-body">
              <div>
                <label className="lead">Race Date:</label>
                <DatePicker
                  selected={Date.parse(newRace.RaceDate)}
                  dateFormat="MM/dd/yyyy"
                  className="form-control mb-2"
                  wrapperClassName="datePicker"
                  id="DateFrom"
                  name="DateFrom"
                  autoComplete="off"
                  placeholderText="Date"
                  onChange={(date) =>
                    setNewRace({ ...newRace, RaceDate: date })
                  }
                />
              </div>

              {gameProviders && (
                <div className="mb-2">
                  <ProviderCbxFilter
                    gameProviders={gameProviders}
                    setSelectedProvider={setSelectedProvider}
                    selectedProvider={selectedProvider}
                    widthCbx={"100%"}
                    label={true}
                  />
                </div>
              )}
              <SelectInputTrack
                id="trackCode"
                label="Track Code:"
                type="select"
                onChange={onChangeTrackCode}
                name="TrackCode"
                className="form-control mb-2"
                value={newRace.TrackCode || ""}
                error={errors.trackId}
                optionsSelect={tracksListCbx}
                isOpen={isOpen}
              ></SelectInputTrack>
              <form autoComplete="off">
                <TextInput
                  id="totalRaces"
                  label="Total Races:"
                  name="TotalRaces"
                  type="number"
                  changeColor={true}
                  onChange={onChangeNewRace}
                  value={newRace.TotalRaces}
                  min="0"
                  error={errors.totalRaces}
                />
              </form>
              <TextInput
                id="totalEntries"
                label="Total Entries:"
                name="TotalEntries"
                type="number"
                changeColor={true}
                onChange={onChangeNewRace}
                value={newRace.TotalEntries}
                min="0"
                error={errors.totalEntries}
              />
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-success"
                onClick={() => insertRace()}
              >
                Save
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={() => closeModalNewRace()}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewRaceModal;
